module.exports = __webpack_public_path__ + "media/images/shared/icon_clip-16cd3d1de683fe34d432ea35e95c2849.svg";